import React from "react";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getEmployment = async () => {
  return await get<ApiResponse<any[]>>(`/employment`).then((res)=>{
      return res
    })
};
